import { render, staticRenderFns } from "./VideoAnglesDialog.vue?vue&type=template&id=b6b2a31c&scoped=true&"
import script from "./VideoAnglesDialog.vue?vue&type=script&lang=js&"
export * from "./VideoAnglesDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnglesDialog.vue?vue&type=style&index=0&id=b6b2a31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b2a31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VProgressCircular,VSpacer})
